const icon = new URL('../../icons/camera.png', import.meta.url).href

export default {
  type: 'camera',
  description: '3D camera',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'camera',
    left: 100,
    top: 100,
    width: 100,
    height: 100,
    depth: 50,
    fillStyle: '#CCAA76',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1,
    far: 100000,
    fov: 80,
    near: 1,
    zoom: 1,
    showHelper: true
  }
}
